import { REACT_APP_ENV } from '~/constants/environment'

export const isDebugMode = (env = ['development', 'integration']) =>
  env.includes(REACT_APP_ENV)

export const useDebugMode = (key, env = ['development', 'integration']) =>
  env.includes(REACT_APP_ENV)
